module.exports = __webpack_public_path__ + "static/homepage-634d26569704b9e0081c3fa0a6243d3f.jpg";